import React, { useState } from 'react';
import {
    TextField,
    Grid,
} from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { updateProfile } from '@common/utils/cart';

function Details({ data, setProfileData }) {

    const [editable, setEditable] = useState(false);

    const editableHandleChange = () => {
        if (editable) {
            setEditable(false);
        } else {
            setEditable(true);
        }
    }

    const updatePersonalDetails = () => {
        // Submit form programmatically
        formik.handleSubmit();
    };

    // console.log('data', data)
    // Formik setup
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            firstName: data?.firstName || '',
            lastName: data?.lastName || '',
            phone: data?.phone || '',
            email: data?.email || '',
        },
        validationSchema: Yup.object({
            firstName: Yup.string()
                .required('First name is required'),
            lastName: Yup.string()
                .required('Last name is required'),
            phone: Yup.string()
                .required('Mobile number is required')
                .matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits'),
        }),
        onSubmit: async (values, { resetForm }) => {
            // console.log('Updated Details:', values);
            // Add your API call or update logic here
            const response = await updateProfile(values) // Call the API to add the address

            // console.log('Address added successfully:', response);
            if (response) {
                // console.log('setProfileData', response);
                setProfileData(response);
                resetForm() // Reset the form after successful submission
                setEditable(false) // Close the form
            }
        },
    });

    return (
        <div className='bs-details'>
            <div className='bs-details__header'>
                <h2 className='bs-details__title'>personal details</h2>
                {!editable ? (
                    <button className='bs-btn bs-btn__btn-icon-link bs-btn__btn-icon-link--decoration-underline' onClick={editableHandleChange}>
                        <span className='bs-btn__icon icon icon-edit'></span>
                        <span className='bs-btn__btn-text'>edit details</span>
                    </button>
                ) : (<>
                    <button className='bs-btn bs-btn__btn-icon-link bs-btn__btn-icon-link--decoration-underline' onClick={updatePersonalDetails}>
                        {/* <span className='bs-btn__icon icon icon-edit'></span> */}
                        <span className='bs-btn__btn-text'>save details</span>
                    </button>
                </>)}
            </div>
            <div className='bs-details__body'>
                {!editable ? (
                    <div className='bs-details__info-wrap'>
                        <Grid container columnSpacing={4.8} rowSpacing={3.2}>
                            <Grid item md={6} xs={12}>
                                <label className='bs-details__info-label'>first name</label>
                                <p className='bs-details__info-value'>{data?.firstName}</p>
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <label className='bs-details__info-label'>last name</label>
                                <p className='bs-details__info-value'>{data?.lastName}</p>
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <label className='bs-details__info-label'>mobile number</label>
                                <p className='bs-details__info-value'>{data?.phone}</p>
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <label className='bs-details__info-label'>email id</label>
                                <p className='bs-details__info-value bs-details__info-value--text-initail'>{data?.email}</p>
                            </Grid>
                        </Grid>
                    </div>
                ) : (
                    <div className='bs-details__form-wrap'>
                        <form
                            className='bs-form bs-form--typ-column'
                            onSubmit={formik.handleSubmit}
                        >
                            <Grid container columnSpacing={4.8} rowSpacing={3.2}>
                                <Grid item md={6} xs={12}>
                                    <div className={`bs-form__form-group`}>
                                        <TextField
                                            id="firstName"
                                            name="firstName"
                                            type="text"
                                            label="First Name"
                                            className='bs-form__form-control'
                                            value={formik.values.firstName}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                                            helperText={formik.touched.firstName && formik.errors.firstName}
                                        />
                                    </div>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <div className={`bs-form__form-group`}>
                                        <TextField
                                            id="lastName"
                                            name="lastName"
                                            type="text"
                                            label="Last Name"
                                            className='bs-form__form-control'
                                            value={formik.values.lastName}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                                            helperText={formik.touched.lastName && formik.errors.lastName}
                                        />
                                    </div>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <div className={`bs-form__form-group`}>
                                        <TextField
                                            id="phone"
                                            name="phone"
                                            type="text"
                                            label="Mobile Number"
                                            className='bs-form__form-control'
                                            value={formik.values.phone}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.phone && Boolean(formik.errors.phone)}
                                            helperText={formik.touched.phone && formik.errors.phone}
                                        />
                                    </div>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <div className={`bs-form__form-group`}>
                                        <TextField
                                            id="email"
                                            name="email"
                                            type="text"
                                            label="Email ID"
                                            className='bs-form__form-control'
                                            value={formik.values.email}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </form>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Details